/*
  InvoicePreviewDialog.jsx — Preview an invoice + Send/PNG/PDF quick actions.
  Extracted from InvoicesPanel.jsx (Feb 2026 refactor).
*/
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FileText, FileImage, Send } from "lucide-react";
import InvoiceDocument from "@/components/collection/InvoiceDocument";

export default function InvoicePreviewDialog({
  open, onOpenChange, preview, company, absolinLogoUrl, downloadPDF, downloadPNG, openSend,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[900px] max-h-[95vh] overflow-y-auto" data-testid="invoice-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between gap-2">
            <span className="flex items-center gap-2">
              <FileText className="w-4 h-4 text-[#0066CC]" />
              {preview?.invoice_no ? `Invoice ${preview.invoice_no}` : "Draft Invoice"}
            </span>
            <div className="flex gap-1">
              {preview && preview.status !== "draft" && (
                <Button variant="outline" size="sm" onClick={() => { onOpenChange(false); openSend(preview); }} className="gap-1"><Send className="w-3.5 h-3.5" /> Send</Button>
              )}
              <Button variant="ghost" size="sm" onClick={() => downloadPNG(preview)} className="gap-1"><FileImage className="w-3.5 h-3.5" /> PNG</Button>
              <Button variant="ghost" size="sm" onClick={() => downloadPDF(preview)} className="gap-1"><FileText className="w-3.5 h-3.5" /> PDF</Button>
            </div>
          </DialogTitle>
        </DialogHeader>
        {preview && (
          <div className="bg-slate-100 border rounded overflow-auto flex justify-center" style={{ maxHeight: "72vh" }}>
            <div style={{ transform: "scale(0.85)", transformOrigin: "top center" }}>
              <InvoiceDocument invoice={preview} company={company} absolinLogoUrl={absolinLogoUrl} />
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
